































































































































































import { Dictionary } from "lodash";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { ACTION } from ".";
import MyColorPicker from "../common/MyColorPicker.vue";
import {
  ApiMessage,
  GetUnitsResponse,
  UnitsApi,
  VariableModel,
  VariablesApi,
} from "../../../apis";

const initBooleanArray = (length: number): boolean[] => {
  let arr = [];
  for (let i = 0; i < length; i++) {
    arr.push(false);
  }
  return arr;
};

@Component({
  components: { ValidationProvider, ValidationObserver, MyColorPicker },
})
export default class VariableDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({}) mode: ACTION;
  @Prop({ default: false }) unit: boolean;
  @Prop({}) selectedVariable?: VariableModel;
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;

  getUnitsResponse: GetUnitsResponse = null;
  unitEditable = false;
  formVariable?: {
    unitId?: string;
    variableName?: string;
    memory?: string;
    type?: string;
    icon?: string;
    color?: string;
    recommendeAction?: string;
    checkbox?: boolean[];
  } = {};

  get show() {
    this.formVariable = {
      unitId: "",
      variableName: "",
      memory: "",
      type: "",
      icon: "",
      recommendeAction: "",
      color: "",
      checkbox: initBooleanArray(14),
    };
    return this.value;
  }

  set show(value) {
    if (this.observer) this.observer.reset();
    this.$emit("input", value);
  }

  get apiMessages(): Dictionary<ApiMessage[]> {
    return this.$store.getters.apiMessages;
  }

  @Watch("apiMessages", { deep: true })
  apiMessagesWatch(messages: Dictionary<ApiMessage[]>) {
    this.$util.showApiError(messages, this.observer);
  }

  get UNITS() {
    return this.getUnitsResponse
      ? this.getUnitsResponse.data.map((val) => ({
          text: val.name,
          value: val.id,
        }))
      : [];
  }

  get TYPES() {
    return [
      { text: "Bool", value: "BOOL" },
      { text: "Byte", value: "BYTE" },
      { text: "UByte", value: "UBYTE" },
      { text: "Word", value: "WORD" },
      { text: "Floating", value: "FLOATING" },
      { text: "Time", value: "TIME" },
    ];
  }

  get ICONS() {
    return [
      { id: 1, text: "O2 Down", value: "O2_DOWN" },
      { id: 2, text: "Flushing", value: "FLUSHING" },
      { id: 3, text: "Pulldown", value: "PULLDOWN" },
      { id: 4, text: "O2 Up", value: "O2_UP" },
      { id: 5, text: "Ventilator", value: "VENTILATOR" },
      { id: 6, text: "Heater", value: "HEATER" },
      { id: 7, text: "Humidifier", value: "HUMIDIFIER" },
      { id: 8, text: "Dehumidification", value: "DEHUMIDIFICATION" },
      { id: 9, text: "Overflow (give)", value: "OVERFLOW_GIVE" },
      { id: 10, text: "Overflow (receive)", value: "OVERFLOW_RECEIVE" },
      { id: 11, text: "Air compressor", value: "AIR_COMPRESSOR" },
      { id: 12, text: "N2 generator", value: "N2_GENERATOR" },
      { id: 13, text: "Green Light", value: "GREEN_LIGHT" },
      { id: 14, text: "Red Light", value: "RED_LIGHT" },
      { id: 15, text: "Tempt Up", value: "TEMPT_UP" },
      { id: 16, text: "Temp Down", value: "TEMP_DOWN" },
    ];
  }

  get CHECKBOXES() {
    return [
      this.$t("text.alarm"),
      this.$t("text.startStop"),
      this.$t("text.o2Up"),
      this.$t("text.remainingO2DownTime"),
      this.$t("text.greenButton"),
      this.$t("text.home"),
      this.$t("text.status"),
      this.$t("text.parameter"),
      this.$t("text.calibrationParameter"),
      this.$t("text.readonly"),
      this.$t("text.operationTime"),
      this.$t("text.inProgress"),
      this.$t("text.recordData"),
      this.$t("text.graph"),
    ];
  }

  resetCheckbox(...val: number[]) {
    if (this.formVariable.checkbox.length >= 11) {
      val.forEach((index) => {
        this.formVariable.checkbox[index] = false;
      });
    }
  }

  isDisabled(index: number) {
    // Read only just enable for Parameter and C.Parameters
    if (index == 9){
      if  (this.formVariable.checkbox[7] || this.formVariable.checkbox[8]){
        return true;
      }
      return false;
    }
    if (this.formVariable.type === "BOOL") {
      this.resetCheckbox(3, 5);
      if (index === 13) {
        return true;
      }
      if ((index === 11 && this.formVariable.checkbox[0]) || (index === 0 && this.formVariable.checkbox[11]) ) {
        return false;
      }
      if ([0, 1 , 2, 4, 7, 8].includes(index)){
        for (const key of [0, 1 , 2, 4, 7, 8]) {
        if (this.formVariable.checkbox[key]) {
          return key === index;
        }
      }
      }
      return [0, 1, 2, 4, 6, 7, 8, 10, 11, 12, 13].includes(index);
    }

    if (this.formVariable.type && [6, 7, 8].includes(index)) {
      return true;
    }
    if (this.formVariable.type === "TIME") {
      this.resetCheckbox(0, 1, 2, 4, 5, 10, 11, 12, 13);
      return [3].includes(index);
    }
    if (["BYTE", "UBYTE", "WORD" , "FLOATING"].includes(this.formVariable.type)) {
      this.resetCheckbox(0, 1, 2, 3, 4, 10, 11, 12);
      return [5, 13].includes(index);
    }
    return false;
  }

  @Watch("formVariable.type")
  onFormVariableTypeWatch(val) {
    if (val !== "BOOL") {
      this.formVariable.icon = "";
    }
  }

  async onSubmit() {
    const { id, plcId } = this.$route.params;
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    this.$util.showLoading();
    try {
      if (this.mode === ACTION.NEW_VARIABLE) {
        await new VariablesApi().createVariable({
          postVariableRequest: {
            controller: plcId,
            unit: this.formVariable.unitId || "",
            variableName: this.formVariable.variableName,
            color: this.formVariable.color,
            memory: this.formVariable.memory,
            type: this.formVariable.type,
            icon: this.formVariable.icon,
            recommendedAction: this.formVariable.recommendeAction,
            alarm: this.formVariable.checkbox[0],
            startStop: this.formVariable.checkbox[1],
            o2Up: this.formVariable.checkbox[2],
            remainingO2DownTime: this.formVariable.checkbox[3],
            greenButton: this.formVariable.checkbox[4],
            home: this.formVariable.checkbox[5],
            status: this.formVariable.checkbox[6],
            parameter: this.formVariable.checkbox[7],
            calibrationParameter: this.formVariable.checkbox[8],
            readOnly: this.formVariable.checkbox[9],
            operationTime: this.formVariable.checkbox[10],
            inProgress: this.formVariable.checkbox[11],
            recordData: this.formVariable.checkbox[12],
            graph: this.formVariable.checkbox[13],
          },
        });
      }
      if (this.mode === ACTION.EDIT_VARIABLE) {
        await new VariablesApi().updateVariable({
          id: this.selectedVariable.id,
          putVariableRequest: {
            controller: plcId,
            unit: this.formVariable.unitId || "",
            recommendedAction: this.formVariable.recommendeAction,
            variableName: this.formVariable.variableName,
            color: this.formVariable.color,
            memory: this.formVariable.memory,
            type: this.formVariable.type,
            icon: this.formVariable.icon,
            alarm: this.formVariable.checkbox[0],
            startStop: this.formVariable.checkbox[1],
            o2Up: this.formVariable.checkbox[2],
            remainingO2DownTime: this.formVariable.checkbox[3],
            greenButton: this.formVariable.checkbox[4],
            home: this.formVariable.checkbox[5],
            status: this.formVariable.checkbox[6],
            parameter: this.formVariable.checkbox[7],
            calibrationParameter: this.formVariable.checkbox[8],
            readOnly: this.formVariable.checkbox[9],
            operationTime: this.formVariable.checkbox[10],
            inProgress: this.formVariable.checkbox[11],
            recordData: this.formVariable.checkbox[12],
            graph: this.formVariable.checkbox[13],
          },
        });
      }
      this.show = false;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onShow() {
    const { id } = this.$route.params;
    this.getUnitsResponse = (
      await new UnitsApi().getUnitByLocationId({ locationId: id })
    ).data;
    this.unitEditable = false;
    if (this.mode === ACTION.EDIT_VARIABLE) {
      this.formVariable.unitId = this.selectedVariable.unitId;
      this.formVariable.variableName = this.selectedVariable.variableName;
      this.formVariable.memory = this.selectedVariable.memory;
      this.formVariable.recommendeAction =
        this.selectedVariable.recommendedAction;
      this.formVariable.icon = this.selectedVariable.icon;
      this.formVariable.type = this.selectedVariable.type;
      this.formVariable.color = this.selectedVariable.color;
      if (!this.formVariable.checkbox) {
        this.formVariable.checkbox = initBooleanArray(14);
      }
      this.formVariable.checkbox[0] = this.selectedVariable.alarm;
      this.formVariable.checkbox[1] = this.selectedVariable.startStop;
      this.formVariable.checkbox[2] = this.selectedVariable.o2Up;
      this.formVariable.checkbox[3] = this.selectedVariable.remainingO2DownTime;
      this.formVariable.checkbox[4] = this.selectedVariable.greenButton;
      this.formVariable.checkbox[5] = this.selectedVariable.home;
      this.formVariable.checkbox[6] = this.selectedVariable.status;
      this.formVariable.checkbox[7] = this.selectedVariable.parameter;
      this.formVariable.checkbox[8] =
        this.selectedVariable.calibrationParameter;
      this.formVariable.checkbox[9] = this.selectedVariable.readOnly;
      this.formVariable.checkbox[10] = this.selectedVariable.operationTime;
      this.formVariable.checkbox[11] = this.selectedVariable.inProgress;
      this.formVariable.checkbox[12] = this.selectedVariable.recordData;
      this.formVariable.checkbox[13] = this.selectedVariable.graph;

      if (!this.formVariable.unitId || !this.unit) {
        this.unitEditable = true;
      }
    }
  }
}
